function compareNumericString(possibleId = '') {
  return (
    rowA: Record<string, Record<string, any>>,
    rowB: Record<string, Record<string, any>>,
    id: string,
    desc: boolean
  ) => {
    let a = rowA.values[id] || rowA.original[possibleId] || 0;
    let b = rowB.values[id] || rowB.original[possibleId] || 0;

    if (typeof a === 'string') {
      a = Number.parseFloat(a.replace(/[^\d.-]/g, ''));
      b = Number.parseFloat(b.replace(/[^\d.-]/g, ''));
    }

    if (Number.isNaN(a)) {
      // Blanks and non-numeric strings to bottom
      a = desc ? Number.NEGATIVE_INFINITY : Number.POSITIVE_INFINITY;
    }
    if (Number.isNaN(b)) {
      b = desc ? Number.NEGATIVE_INFINITY : Number.POSITIVE_INFINITY;
    }
    if (a > b) {
      return 1;
    }
    if (a < b) {
      return -1;
    }

    return 0;
  };
}

function compareTradeDateString(
  rowA: Record<string, Record<string, number>>,
  rowB: Record<string, Record<string, number>>
): number {
  const a = rowA.original;
  const b = rowB.original;

  if (a.timestamp > b.timestamp) {
    return 1;
  }

  if (a.timestamp < b.timestamp) {
    return -1;
  }

  return a.order - b.order;
}

export {
  compareNumericString,
  compareTradeDateString,
};
